import React from 'react';

import { ColorPalette, Text, Theme } from '@lumapps/lumx/react';

import { BlockPostIdeaStatus } from '../../../types';

interface PostIdeaStatus {
    /** User can edit post. */
    className?: string;
    /** Post idea status. */
    ideaStatus?: BlockPostIdeaStatus;
    /** Theme */
    theme?: Theme;
}

export const PostIdeaStatus: React.FC<PostIdeaStatus> = ({ className, ideaStatus, theme }) => {
    if (!ideaStatus) {
        return null;
    }

    return (
        <Text as="span" className={className} color={theme === Theme.dark ? ColorPalette.light : ColorPalette.primary}>
            {ideaStatus.label}
        </Text>
    );
};
